import React from 'react'
import LearnComponent from '../../components/collaboration-hub-component/CollaborationHubComponent'

function Learn() {
  return (
    <div><LearnComponent/></div>
  )
}

export default Learn